import { formatDuraton } from '@/utils/util'
import VideoEnPlayer from '../Player'
import VideoEvents from '../event'

export default class VideoTouchInt {
  player: VideoEnPlayer
  event: VideoEvents
  progressType: 'click' | 'move'

  constructor(player: VideoEnPlayer, event: VideoEvents) {
    this.player = player
    this.event = event
    this.progressType = 'click'

    this.mouseMoveFun = this.mouseMoveFun.bind(this)
    this.mouseUpFun = this.mouseUpFun.bind(this)

    this.addEvent(event, player)
  }

  addEvent(event, player) {
    let startEventName = 'mousedown'
    let moveEventName = 'mousemove'
    let endEventName = 'mouseup'
    const isMobile = /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile|iPhone|Mobile/.test(navigator.userAgent)

    if (isMobile) {
      startEventName = 'touchstart'
      moveEventName = 'touchmove'
      endEventName = 'touchend'
    }
    event.proxy(player.template.$bottomProgressBlock, 'click', (e) => {
      e.stopPropagation()
      e.stopImmediatePropagation()

      event.layerDom.tooglePlayerBottom(true)
      event.clearSetTimeOut()

      const clickX = e.clientX - player.template.$bottomProgressBlock.getBoundingClientRect().left
      const progressWidth = player.template.$bottomProgressBlock.offsetWidth

      // 计算点击位置相对于 player-progress 的宽度百分比
      let width = clickX / progressWidth
      const currentTime = width * player.player.getDuration()

      player.template.$video.currentTime = currentTime

      width = width * 100

      width = width > 100 ? 100 : width < 0 ? 0 : width

      player.template.$bottomLoaded.style.width = `${width}%`

      event.layerDom.tooglePlayerBottom(false, true)
    })

    event.proxy(isMobile ? player.template.$bottomProgressBlock : player.template.$bottomProgressDrag, startEventName, () => {
      if (player.player.getStatus() === 'loading') {
        return
      }

      if (isMobile) {
      } else {
        event.isDragging = true
      }

      event.layerDom.tooglePlayerBottom(true)
      event.clearSetTimeOut()

      document.addEventListener('mousemove', this.mouseMoveFun)
      document.addEventListener('mouseup', this.mouseUpFun)
    })

    if (isMobile) {
      event.proxy(player.template.$bottomProgressBlock, moveEventName, (e) => {
        if (isMobile) {
          event.isDragging = true
        }

        if (event.isDragging) {
          const touch = isMobile ? e.touches[0] : e
          const playerProgressRect = player.template.$bottomProgress.getBoundingClientRect()
          const progressWidth = playerProgressRect.width
          const touchX = touch.clientX - playerProgressRect.left

          if (Math.abs(touchX) > 5) {
            this.progressType = 'move'

            // 计算移动的百分比
            let percentage = (touchX / progressWidth) * 100

            percentage = percentage > 100 ? 100 : percentage < 0 ? 0 : percentage

            const currentTime = (percentage / 100) * player.player.getDuration()

            // 设置 player-loaded 的宽度为百分比值
            player.template.$video.currentTime = currentTime > player.player.getDuration()
              ? player.player.getDuration() : currentTime < 0 ? 0 : currentTime

            // 设置 player-loaded 的宽度为百分比值
            player.template.$bottomCurrent.innerHTML = `${formatDuraton(currentTime)}`
            player.template.$bottomLoaded.style.width = `${percentage}%`
            player.template.$miniProgressLoaded.style.width = `${percentage}%`
          } else {
            this.progressType = 'click'
          }
        }
      })

      event.proxy(player.template.$bottomProgressBlock, endEventName, (e) => {
        if (this.progressType === 'move') {
          event.isDragging = false
          event.clearSetTimeOut()

          if (player.template.$container) {
            let width = player.template.$bottomLoaded.style.width

            if (width) {
              width = width.split('%')[0]

              if (width) {
                width = Number(width)

                width = width / 100
                const currentTime = width * player.player.getDuration()

                player.template.$video.currentTime = currentTime > player.player.getDuration()
                  ? player.player.getDuration() : currentTime < 0 ? 0 : currentTime

                player.template.$bottomCurrent.innerHTML = `${formatDuraton(currentTime)}`
                player.template.$bottomLoaded.style.width = `${width * 100}%`
                player.template.$miniProgressLoaded.style.width = `${width * 100}%`

                event.layerDom.tooglePlayerBottom(false, true)
                this.progressType = 'click'
              }
            }
          }
        } else {
          event.isDragging = false
          const playerProgressRect = player.template.$bottomProgress.getBoundingClientRect()
          const touch = isMobile ? e.changedTouches[0] : e
          const touchX = touch.clientX - playerProgressRect.left

          // 计算移动的百分比
          let percentage = (touchX / playerProgressRect.width) * 100

          percentage = percentage > 100 ? 100 : percentage < 0 ? 0 : percentage

          const width = percentage / 100
          const currentTime = width * player.player.getDuration()

          player.template.$video.currentTime = currentTime > player.player.getDuration()
            ? player.player.getDuration() : currentTime < 0 ? 0 : currentTime

          player.template.$bottomCurrent.innerHTML = `${formatDuraton(currentTime)}`
          player.template.$bottomLoaded.style.width = `${percentage}%`
          player.template.$miniProgressLoaded.style.width = `${percentage}%`

          event.layerDom.tooglePlayerBottom(false, true)
          this.progressType = 'click'
        }
      })
    }
  }

  mouseMoveFun(e) {
    if (this.event.isDragging) {
      const touch = e
      const playerProgressRect = this.player.template.$bottomProgress.getBoundingClientRect()
      const progressWidth = playerProgressRect.width
      const touchX = touch.clientX - playerProgressRect.left

      if (Math.abs(touchX) > 5) {
        this.progressType = 'move'

        // 计算移动的百分比
        let percentage = (touchX / progressWidth) * 100

        percentage = percentage > 100 ? 100 : percentage < 0 ? 0 : percentage

        const currentTime = (percentage / 100) * this.player.player.getDuration()

        // 设置 player-loaded 的宽度为百分比值
        this.player.template.$bottomCurrent.innerHTML = `${formatDuraton(currentTime)}`
        this.player.template.$bottomLoaded.style.width = `${percentage}%`
        this.player.template.$miniProgressLoaded.style.width = `${percentage}%`


      } else {
        this.progressType = 'click'
      }
    }
  }

  mouseUpFun() {
    document.removeEventListener('mousemove', this.mouseMoveFun)
    document.removeEventListener('mouseup', this.mouseUpFun)
    this.event.isDragging = false

    if (this.progressType === 'move') {
      this.event.clearSetTimeOut()

      if (this.player.template.$container) {
        let width: any = this.player.template.$bottomLoaded.style.width

        if (width) {
          width = width.split('%')[0]

          if (width) {
            width = Number(width)

            width = width / 100
            const currentTime = width * this.player.player.getDuration()

            this.player.template.$video.currentTime = currentTime > this.player.player.getDuration()
              ? this.player.player.getDuration() : currentTime < 0 ? 0 : currentTime

            this.player.template.$bottomCurrent.innerHTML = `${formatDuraton(currentTime)}`
            this.player.template.$bottomLoaded.style.width = `${width * 100}%`
            this.player.template.$miniProgressLoaded.style.width = `${width * 100}%`

            this.event.layerDom.tooglePlayerBottom(false, true)
            this.progressType = 'click'
          }
        }
      }
    }
  }
}
